import { useCallback, useState, useRef } from "react";

export function useGetSubmenuRef() {
  const menuRef = useRef<HTMLDivElement | null>(null);
  const [root, setRoot] = useState<HTMLDivElement | null>(null);
  const [subStatusRoot, setsubStatusRoot] = useState<HTMLUListElement | null>(
    null
  );
  const [subWorkerRoot, setsubWorkerRoot] = useState<HTMLUListElement | null>(
    null
  );
  const [subReasonRoot, setsubReasonRoot] = useState<HTMLUListElement | null>(
    null
  );
  const [subFixRoot, setsubFixRoot] = useState<HTMLUListElement | null>(null);
  const [subInspectorRoot, setsubInspectorRoot] =
    useState<HTMLUListElement | null>(null);

  const getSubmenuRef = useCallback(
    (submenuType: string | null): HTMLElement | null => {
      if (!submenuType) return null;
      switch (submenuType) {
        case "worker":
          return subWorkerRoot;
        case "reason":
          return subReasonRoot;
        case "fix":
          return subFixRoot;
        case "status":
          return subStatusRoot;
        case "inspector":
        case "assign-inspector":
          return subInspectorRoot;
        case "cover":
          return subFixRoot;
        default:
          return null;
      }
    },
    [subStatusRoot, subWorkerRoot, subReasonRoot, subFixRoot, subInspectorRoot]
  );

  return {
    menuRef,
    root,
    setRoot,
    subStatusRoot,
    setsubStatusRoot,
    subWorkerRoot,
    setsubWorkerRoot,
    subReasonRoot,
    setsubReasonRoot,
    subFixRoot,
    setsubFixRoot,
    subInspectorRoot,
    setsubInspectorRoot,
    getSubmenuRef,
  };
}
